import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PhotoCameraBackIcon(props: IconProps) {
    return <Icon {...props} iconKey={"photo_camera_back"}/>
}
